export default __webpack_public_path__ + "static/media/uploadFile.6f5e7194.svg";